import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    Button,
    Loading,
    Table,
    Pagination,
    Modal,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";

import { EmptyRow } from "../../components/EmptyRow";
import { Workflow } from "../../forms/WorkflowForm";

const PaddedDiv = styled.div`
    padding: 3em;
`;

const TableHeader = styled.div`
    cursor: pointer;
    display: inline-block;

    &:hover {
        text-decoration: underline;
    }
`;

export const WorkflowTable = ({
    items,
    loaded,
    path,
    pagination = null,
    deleteItem,
    onPageChange,
    onOrderBy,
    onPerPageChange,
}: RoleTableProps) => {
    const currentPage = pagination ? pagination.current_page : 1;

    const [deleteEntityModalShowing, setDeleteEntityModalShowing] =
        useState(false);
    const [deleteEntityName, setDeleteEntityName] = useState("");
    const [deleteEntityId, setDeleteEntityId] = useState(null);

    return (
        <React.Fragment>
            <Table>
                <thead>
                    <tr>
                        <th>{trans("Name")}</th>
                        <th>
                            <TableHeader onClick={() => onOrderBy("status")}>
                                {trans("Status")}
                            </TableHeader>
                        </th>
                        <th>{trans("Actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {!loaded ? (
                        <EmptyRow colSpan={3}>
                            <Loading />
                        </EmptyRow>
                    ) : !items || items.length === 0 ? (
                        <EmptyRow colSpan={3}>
                            {trans("No items found")}
                        </EmptyRow>
                    ) : (
                        items.map((item) => {
                            return (
                                <tr>
                                    <td>{item.name}</td>
                                    <td>{item.status}</td>
                                    <td>
                                        <IconTextButton
                                            as={Link}
                                            to={`${path}/edit/${item.uuid}?page=${currentPage}`}
                                            showCircle={false}
                                            expanded={false}
                                            icon={faEdit}
                                        >
                                            {trans("Edit")}
                                        </IconTextButton>
                                        <IconTextButton
                                            type="alert"
                                            showCircle={false}
                                            expanded={false}
                                            icon={faTrash}
                                            onClick={(event) => {
                                                setDeleteEntityId(item.uuid);
                                                setDeleteEntityModalShowing(
                                                    true
                                                );
                                                setDeleteEntityName(item.name);
                                            }}
                                        >
                                            {trans("Delete")}
                                        </IconTextButton>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
            {pagination && (
                <Pagination
                    onPerPageChange={onPerPageChange}
                    style={{ clear: "both" }}
                    currentPage={pagination.current_page - 1}
                    perPage={pagination.per_page}
                    pageCount={pagination.last_page}
                    onPageChange={({ selected }) => onPageChange(selected + 1)}
                    {...pagination}
                />
            )}
            {deleteEntityModalShowing && (
                <Modal
                    visible={deleteEntityModalShowing}
                    onClose={() => {
                        setDeleteEntityModalShowing(false);
                    }}
                >
                    <PaddedDiv>
                        <h1>
                            {trans("You are about delete workflow")}:{" "}
                            {deleteEntityName}
                        </h1>

                        <p>{trans("Are you sure you want to proceed?")}</p>
                        <Button
                            type="hollow"
                            style={{ marginRight: "1em" }}
                            onClick={() => {
                                setDeleteEntityModalShowing(false);
                            }}
                        >
                            {trans("Cancel")}
                        </Button>
                        <Button
                            type="alert"
                            onClick={() => {
                                deleteItem(deleteEntityId).catch((e) =>
                                    setDeleteEntityModalShowing(false)
                                );
                            }}
                        >
                            {trans("Delete")}
                        </Button>
                    </PaddedDiv>
                </Modal>
            )}
        </React.Fragment>
    );
};

interface RoleTableProps {
    items: Workflow[];
    loaded: boolean;
    path: string;
    pagination?: any;
    deleteItem: (number) => Promise<void>;
    onPageChange?: (number) => void;
    onOrderBy?: (string) => void;
    onPerPageChange?: ({ value }) => void;
}

export default WorkflowTable;
